import React, { useState, useEffect } from 'react';
import './affiliate.css';
import { useLanguage } from '../contexts/LanguageContext';
import resmailLogo from '../assets/resmail.png';
import aboutLogo from '../assets/lamp.svg';
import affiliateImage from '../assets/affiliate-image.svg';
import affiliateImg from '../assets/affiliate-img.svg';

import aff1 from '../assets/affiliate/aff1.svg';
import aff2 from '../assets/affiliate/aff2.svg';
import aff3 from '../assets/affiliate/aff3.svg';
import aff4 from '../assets/affiliate/aff4.svg';
import aff5 from '../assets/affiliate/aff5.1.svg';
import aff6 from '../assets/affiliate/aff6.svg';
import aff7 from '../assets/affiliate/aff7.1.svg';
import aff8 from '../assets/affiliate/aff8.1.svg';
import bubbleImage from '../assets/bubble.svg';
import Table from './table';

function Affiliate() {
    const { isArabic, setLanguage } = useLanguage();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        setLanguage('en');
    }, [setLanguage]);

    const handleSearch = (e) => {
        e.preventDefault();
        // Handle search logic here
        console.log('Searching for:', searchQuery);
    };

    return (
        <div className="affiliate-page">
            <section className="affiliate-hero">
                <div className="affiliate-hero-container">
                    <div className="affiliate-hero-left">
                        {/* <div className="affiliate-search-wrapper">
                            <form onSubmit={handleSearch} className="affiliate-search-form">
                                <input
                                    type="text"
                                    placeholder={isArabic ? "ابحث عن الشركات التابعة..." : "Search for affiliates..."}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="affiliate-search-input"
                                />
                                <button type="submit" className="affiliate-search-button">
                                    {isArabic ? "بحث" : "Search"}
                                </button>
                            </form>
                        </div> */}
                        <div className="affiliate-content">
                            <Table type="affiliate" title="AFFILIATE" pointsLabel="Points" />
                        </div>
                    </div>
                    <div className="affiliate-hero-right">
                        <img src={affiliateImage} alt="Affiliate" className="affiliate-hero-image" />
                    </div>
                </div>
            </section>

            <section className="affiliate-prize-section">
                <div className="affiliate-prize-container">
                    <h2 className="affiliate-prize-title">PRIZE</h2>
                    <div className="affiliate-prize-grid">
                        <div className="affiliate-prize-card">
                            <div className="prize-image-wrapper">
                                <img src={aff1} alt="GA Tickets" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">GA Tickets</p>
                                <p className="prize-points"><strong>5 Points</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card">
                            <div className="prize-image-wrapper">
                                <img src={aff2} alt="Backstage Tickets" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">Backstage Tickets</p>
                                <p className="prize-points"><strong>35 Points</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card">
                            <div className="prize-image-wrapper">
                                <img src={aff3} alt="VIP Tickets" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">VIP Tickets</p>
                                <p className="prize-points"><strong>25 Points</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card">
                            <div className="prize-image-wrapper">
                                <img src={aff4} alt="GA+ Tickets" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">GA+ Tickets</p>
                                <p className="prize-points"><strong>10 Points</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card card5">
                            <div className="prize-image-wrapper">
                                <img src={aff5} alt="Backstage Tour" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">Backstage Tour</p>
                                <p className="prize-points"><strong>50 Points</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card card6">
                            <   div className="prize-image-wrapper">
                                <img src={aff6} alt="Merch Gift Certificates" />
                            </div>
                            <div className="prize-content">
                                {/* <p className="prize-text">Merch Gift Certificates</p> */}
                                {/* <p className="prize-points"><strong>Every 5 points<br />= 100 SAR</strong></p> */}
                                <p className="prize-text">Every 5 points</p>
                                <p className="prize-points"><strong>= 100 SAR</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card card7">
                            <div className="prize-image-wrapper">
                                <img src={aff7} alt="10 Points" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">10 POINTS</p>
                                <p className="prize-points"><strong>250 SAR</strong></p>
                            </div>
                        </div>
                        <div className="affiliate-prize-card card8">
                            <div className="prize-image-wrapper">
                                <img src={aff8} alt="15 Points" />
                            </div>
                            <div className="prize-content">
                                <p className="prize-text">15 POINTS</p>
                                <p className="prize-points"><strong>500 SAR</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="affiliate-redemption-section">
                <div className="affiliate-redemption-container">
                    <div className="affiliate-redemption-content">
                        <div className="affiliate-redemption-text">
                            <h2 className="affiliate-redemption-title">Redemptions<br />will be on<br />4th of February</h2>
                            <p className="affiliate-redemption-contact">
                                Please send an email to<br />
                                <a href="mailto:hello@freaksofnature.me" className="affiliate-redemption-email">
                                    hello@freaksofnature.me
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="affiliate-redemption-image">
                        <img src={affiliateImg} alt="Redemption" className="affiliate-redemption-logo" />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Affiliate;
